import angular from 'angular';

angular.module('cloudX').directive('cxFiscalYearDialogButton', [
  '$q',
  'ModalService',
  function($q, ModalService) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        relation: '=',
        gmType: '=',
        relationId: '=',
      },
      template: `<a ng-click="showFiscalYearsDialog();$event.stopPropagation()"
                    class="margin10L"
                    title="{{('Overview of future fiscal years'|translate)}}">
                  <i class="fa fa-calendar"></i>
                  <span data-translate="Show fiscal years"></span>
                </a>`,
      require: ['^cxRelationFile'],
      link: function($scope, element, attrs, ctrl) {
        var cxRelFile = ctrl[0];
        $scope.showFiscalYearsDialog = function() {
          let relationId = $scope.relationId;
          let gmType = $scope.gmType;
          if ($scope.relation && $scope.relation.id) {
            relationId = $scope.relation.id;
            const { value: gm = {} } =
              $scope.relation['cd2ee705-f073-44e0-8e68-be67c9549683'] || {};
            gmType = gm.type || 0;
          }

          ModalService.showModal({
            template: require('../../relations/dialogs/fiscalYearDialog.html'),
            controller: 'FiscalYearDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              relationId,
              gmType,
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
            modal.close.then(function(result) {
              if (!result) return;
              if (cxRelFile && cxRelFile.refreshOpenSections) cxRelFile.refreshOpenSections();
            });
          });
        };
      },
    };
  },
]);
